import { DayAndTimeSelect } from "@shared/common/components/DayAndTimeSelect";
import React from "react";

export function SBDBottomBar(): React.JSX.Element {
  return (
    <div className="order-3 flex flex-row items-center justify-end gap-4 p-4">
      <DayAndTimeSelect />
    </div>
  );
}
